import { render, staticRenderFns } from "./MidwifeActivityOverview.vue?vue&type=template&id=bfe6b36c"
import script from "./MidwifeActivityOverview.vue?vue&type=script&lang=js"
export * from "./MidwifeActivityOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports